<template>
	<div class="parallax-vertical__container">
		<div ref="asset" class="parallax-vertical__asset">
			<slot name="asset"></slot>
		</div>
	</div>
</template>

<script>
import * as basicScroll from 'basicscroll';

export default {
	name: 'ParallaxVertical',
	mounted() {
		this.$nextTick(function () {
			const instance = basicScroll.create({
				elem: document.querySelector('.parallax-vertical__asset'),
				from: 'top-bottom', //element
				to: 'bottom-top', //viewport
				direct: true,
				props: {
					'--ty-first-letter': {
						from: '0px',
						to: '200px',
					},
					'--ty-second-letter': {
						from: '0px',
						to: '-150px',
					},
					'--ty-third-letter': {
						from: '0px',
						to: '120px',
					},
					'--ty-fourth-letter': {
						from: '0px',
						to: '-100px',
					},
					'--ty-fifth-letter': {
						from: '0px',
						to: '40px',
					},
				},
			});
			instance.start();
		});
	},
};
</script>

<style lang="scss" scoped></style>
